import { httpClient } from "../http-client/base-client";
import {
  ApiPhoneCheckRequest,
  ApiPhoneCheckResponse,
  ApiPhoneRequest,
  ApiPhoneResponse,
} from "../types/auth/api-types";

export const AuthResource = {
  /**
   * Отправка номера телефона для получения кода подтверждения
   * @param phone Номер телефона в формате +7XXXXXXXXXX
   */
  async sendPhone(request: ApiPhoneRequest): Promise<ApiPhoneResponse> {
    const response = await httpClient.post<ApiPhoneResponse>(
      "auth/phone",
      request,
    );
    return response;
  },

  /**
   * Проверка кода подтверждения
   * @param request Объект с номером телефона и кодом подтверждения
   */
  async verifyPhone(
    request: ApiPhoneCheckRequest,
  ): Promise<ApiPhoneCheckResponse> {
    const response = await httpClient.post<ApiPhoneCheckResponse>(
      "auth/phone/check",
      request,
    );
    return response;
  },
};
